import en from "./en.json";
import it from "./it.json";

const finance = { en, it };

export default finance;
